/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';

/**
 * 
 * @export
 * @interface UpdateSiteRequestDto
 */
export interface UpdateSiteRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteRequestDto
     */
    address?: string | null;
    /**
     * French postal code (5 digits).
     * @type {string}
     * @memberof UpdateSiteRequestDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteRequestDto
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSiteRequestDto
     */
    provinceCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSiteRequestDto
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSiteRequestDto
     */
    longitude?: number | null;
    /**
     * Polygon perimeter points describing the covered area.
     * @type {Array<PerimeterPointDto>}
     * @memberof UpdateSiteRequestDto
     */
    perimeter?: Array<PerimeterPointDto> | null;
}

/**
 * Check if a given object implements the UpdateSiteRequestDto interface.
 */
export function instanceOfUpdateSiteRequestDto(value: object): value is UpdateSiteRequestDto {
    return true;
}

export function UpdateSiteRequestDtoFromJSON(json: any): UpdateSiteRequestDto {
    return UpdateSiteRequestDtoFromJSONTyped(json, false);
}

export function UpdateSiteRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSiteRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'cityCode': json['cityCode'] == null ? undefined : json['cityCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'perimeter': json['perimeter'] == null ? undefined : ((json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
    };
}

export function UpdateSiteRequestDtoToJSON(json: any): UpdateSiteRequestDto {
    return UpdateSiteRequestDtoToJSONTyped(json, false);
}

export function UpdateSiteRequestDtoToJSONTyped(value?: UpdateSiteRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'postalCode': value['postalCode'],
        'cityCode': value['cityCode'],
        'provinceCode': value['provinceCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'perimeter': value['perimeter'] == null ? undefined : ((value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
    };
}

